var map = {
	"./ai.png": 647,
	"./android.jpg": 887,
	"./apache.jpg": 96,
	"./aws.svg": 380,
	"./awstf.jpg": 416,
	"./cicd.jpeg": 946,
	"./cicd.png": 729,
	"./devops.jpg": 588,
	"./docker.jpg": 838,
	"./docker.png": 112,
	"./email.png": 122,
	"./gemini.png": 779,
	"./git.jpeg": 530,
	"./github.png": 100,
	"./gtc2.jpg": 560,
	"./jenkins.jpg": 289,
	"./k8s.png": 693,
	"./k8swall.jpg": 659,
	"./medistat.jpg": 362,
	"./protege.jpg": 807,
	"./py.png": 638,
	"./pyqt.png": 834,
	"./rag.png": 533,
	"./react.png": 608,
	"./slack.png": 255,
	"./sonarqube.png": 895,
	"./sp.png": 431,
	"./terraform.svg": 258,
	"./tf.png": 459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 943;